import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, api_service_path } from "./utils"

export const feeCollectionAction = createApi({
    reducerPath: "feeCollection",
    baseQuery: fetchBaseQuery({
        baseUrl: `${baseUrl}/${api_service_path.feeCollection}`,
        prepareHeaders: (headers) => {
            const current_user = localStorage.getItem("current_user") ? JSON.parse(localStorage.getItem("current_user")) : null
            if (current_user?.token) {
                headers.set(
                    "Authorization",
                    `Bearer ${current_user.token}`
                )
            }
            return headers
        }
    }),
    tagTypes: ["fee"],
    endpoints: (builder) => ({
        feeCollector: builder.mutation({
            query: ({
                school_name,
                school_ref,
                fee_name,
                month,
                fee_collection
            }) => ({
                url: "/create",
                method: "POST",
                body: {
                    school_name,
                    school_ref,
                    fee_name,
                    month,
                    fee_collection
                }
            })
        }),
        getMonthlyFeeCollection: builder.query({
            query: ({
                school_id,
                month
            }) => ({
                url: `/get/${school_id}/${month}`,
                method: "GET"
            })
        }),
        getFeeCollectionReports: builder.query({
            query: ({
                school_id,
                collection_type
            }) => ({
                url: `/reports/${school_id}/${collection_type}`,
                method: "GET"
            })
        }),
        collectFee: builder.mutation({
            query: (data) => ({
                url: "/collect_fee",
                method: "POST",
                body: data
            })
        }),
        getStudentPaidData: builder.query({
            query: ({
                school_id,
                student_id
            }) => ({
                url: `/collect_fee/${school_id}/${student_id}`,
                method: "GET"
            })
        })
    })
})

export const {
    useFeeCollectorMutation,
    useLazyGetMonthlyFeeCollectionQuery,
    useLazyGetFeeCollectionReportsQuery,
    useCollectFeeMutation,
    useLazyGetStudentPaidDataQuery
} = feeCollectionAction